<template>
    <div>
        <Navigator />
        <section class="features2 cid-r5nFKMOCYf" id="features2-a">
            <div class="container">
                <div class="media-container-row">
                    <div class="col-md-8 align-center">
                        <h2 class="pb-3 mbr-section-title mbr-fonts-style display-6">
                            这是<strong>{{keyword}}</strong>的页面。第{{page}}页，共{{total}}页。
                        </h2>
                        <div>
                            <div class="mbr-social-likes">

                                <span class="btn btn-social vkontakte socicon-bg-vkontakte mx-2" title="首页">
                                    <router-link :to="{name: 'searchByKeyword', params: {type: type, keyword: keyword, page: 1} }">
                                        <i class="fas fa-fast-backward"></i>
                                    </router-link>
                                </span>

                                <span v-if="page>1" class="btn btn-social odnoklassniki socicon-bg-odnoklassniki mx-2"
                                    title="前页">
                                    <router-link :to="{name: 'searchByKeyword', params: {type: type, keyword: keyword, page: page-1} }">
                                        <i class="fas fa-backward"></i>
                                    </router-link>
                                </span>
                                <span v-else class="btn btn-social odnoklassniki socicon-bg-odnoklassniki mx-2">
                                    <i class="fas fa-backward"></i>
                                </span>
                                <span v-if="page<total" class="btn btn-social pinterest socicon-bg-pinterest mx-2"
                                    title="下页">
                                    <router-link :to="{name: 'searchByKeyword', params: {type: type, keyword: keyword, page: parseInt(page)+1} }">
                                        <i class="fas fa-forward"></i>
                                    </router-link>
                                </span>
                                <span v-else class="btn btn-social odnoklassniki socicon-bg-odnoklassniki mx-2">
                                    <i class="fas fa-forward"></i>
                                </span>
                                <span class="btn btn-social mailru socicon-bg-mail mx-2" title="末页">
                                    <router-link :to="{name: 'searchByKeyword', params: {type: type, keyword: keyword, page: total} }">
                                        <i class="fas fa-fast-forward"></i>
                                    </router-link>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="media-container-row">

                    <div class="card p-3 col-6 col-md-6 col-lg-6">
                        <h4 class="card-title pb-3 mbr-fonts-style display-7" v-for="a in articles.slice(0,5)" :key="a.id">
                            <router-link :to="{name: 'articleById', params: {id: a.id}  }">{{a.title}}</router-link>
                        </h4>

                    </div>
                    <div class="card p-3 col-6 col-md-6 col-lg-6">
                        <h4 class="card-title pb-3 mbr-fonts-style display-7" v-for="a in articles.slice(5,10)" :key="a.id">
                            <router-link :to="{name: 'articleById', params: {id: a.id}  }">{{a.title}}</router-link>
                        </h4>
                    </div>
                </div>

            </div>


        </section>
        <Footer />
    </div>
</template>

<script>
    import Navigator from "@/components/Navigator";
    import Footer from "@/components/Footer";

    export default {
        name: "Search",
        props: [
            "keyword",
            "page",
            "type",
        ],
        components: {
            Navigator,
            Footer
        },
        data: function () {
            return {
                articles: [],
                total: 0,
            }
        },
        methods: {
            getSearchResult() {
                var uri = 'http://api.go4pro.org/go4pro/article/search/' + this.type + "/" + this.keyword + "/" + this.page;

                fetch(uri)
                    .then(res => {
                        return res.json();
                    })
                    .then(json => {
                        this.articles = json.articles;
                        this.total = json.tp;
                    })
            }
        },
        created: function () {
            this.getSearchResult();
        },
        watch: {
            page: function (newV, oldV) {
                if (newV != oldV) {
                    this.getSearchResult();
                }
            },
            keyword: function (n, o) {
                if (n != o) {
                    this.getSearchResult();
                }
            }


        },
        metaInfo() {
            return {
                title: "Go4Pro.org | " + this.type,
                htmlAttrs: {
                    lang: "zh-CN"
                },
                meta: [{
                        name: "description",
                        content: this.type + " by " + this.keyword + ", page " + this.page + " of " + this.total +
                            " pages"
                    },
                    {
                        name: "keyword",
                        content: this.keyword
                    }
                ]
            };
        }

    };
</script>